import ApiService from '../common/api.service';

import {
  CLEAR_USERS_ACTION,
  FETCH_ROLES,
  FETCH_USERS,
  UPDATE_USER,
  CLEAR_ROLES_ACTION,
  REGISTER,
  DELETE_USER,
} from './actions.type';

import {
  SET_ERROR,
  SET_USERS,
  CLEAR_USERS,
  SET_ROLES,
  CLEAR_ROLES,
  SUBMITED_USUARIO_DELETE,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  users: [],
  roles: [],
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  submited_usuario: false,
};

const getters = {
  users(state) {
    return state.users;
  },
  roles(state) {
    return state.roles;
  },
  usuario_submited() {
    return state.submited_usuario;
  },
  alert(state) {
    return state.alert;
  },
  alertMessage(state) {
    return state.alertMessage;
  },
  alertType(state) {
    return state.alertType;
  },
};

const actions = {
  [FETCH_USERS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('usuarios/users')
        .then(({ data }) => {
          context.commit(SET_USERS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.msg]);
        });
    });
  },
  [FETCH_ROLES](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('usuarios/roles')
        .then(({ data }) => {
          context.commit(SET_ROLES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.msg]);
        });
    });
  },
  [UPDATE_USER](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('usuarios/users', { id: data.id, role: data.roleid, password: data.passwd })
        .then(({ data }) => {
          context.dispatch(FETCH_USERS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.msg]);
        });
    });
  },
  [DELETE_USER](context, userId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`usuarios/deleteuser/${userId}`)
        .then(({ data }) => {
          context.commit(SUBMITED_USUARIO_DELETE);
          context.dispatch(FETCH_USERS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.msg]);
        });
    });
  },
  [REGISTER](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('usuarios/registration', { username: data.username, role: data.roleid, password: data.passwd })
        .then(({ data }) => {
          context.dispatch(FETCH_USERS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.msg]);
        });
    });
  },
  [CLEAR_USERS_ACTION](context) {
    context.commit(CLEAR_USERS);
  },
  [CLEAR_ROLES_ACTION](context) {
    context.commit(CLEAR_ROLES);
  },
};

const mutations = {
  [SET_USERS](state, data) {
    state.users = data.usuarios;
  },
  [CLEAR_USERS](state) {
    state.users = [];
  },
  [CLEAR_ROLES](state) {
    state.roles = [];
  },
  [SET_ROLES](state, data) {
    state.roles = data.roles;
  },
  [SUBMITED_USUARIO_DELETE](state) {
    state.alert = true;
    state.alertMessage = 'Usuario Eliminado Correctamente';
    state.alertType = 'success';
    state.submited_usuario = true;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
